import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux'
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import store from './store';

import GoogleAnalyticsConfiguration from './googleAnalytics/googleAnalyticsConfiguration';

GoogleAnalyticsConfiguration.initiateGA();
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
